// product.js
// Action Creators for List operations

/****************************************************************
 * Actions
 ****************************************************************/
// Available Actions
export const ORDER_SET_PRODUCT     = 'ORDER_SET_PRODUCT';
export const ORDER_SET_ADJUSTMENT  = 'ORDER_SET_ADJUSTMENT';
export const ORDER_CLOSE           = 'ORDER_CLOSE';
export const ORDER_REOPEN          = 'ORDER_REOPEN';


/****************************************************************
 * Action Creators
 ****************************************************************/
// Adds a given product to the order of a given client
export function setOrderProduct (clientId, productId, unitId, quantity, customPrice = undefined) {
  return {
    type: ORDER_SET_PRODUCT,
    clientId,
    productId,
    unitId,
    quantity,
    customPrice,
  }
}

// Sets and adjustment value and optional description to the order of a given client.
// If value is 0 or null, the adjustment is removed.
export function setOrderAdjustment (clientId, value, description = undefined) {
  return {
    type: ORDER_SET_ADJUSTMENT,
    clientId,
    value,
    description,
  }
}

// Closes and archives the current open order
export function closeOrder (products) {
  return {
    type: ORDER_CLOSE,
    products
  }
}

// Discards current order and reopens last order
export function reopenOrder () {
  return {
    type: ORDER_REOPEN,
  }
}



// WEBPACK FOOTER //
// ./src/actions/order.js